module.exports = __webpack_public_path__ + "img/event_icon_selected.ffd36ed5.svg";